import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from 'helpers/styles/contextMenu'
import Marker from './marker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateEntityAction, destroyDoorControllerAction, deleteDoorAction } from 'actions/entityActions'
import { updateCurrentEntityAction } from 'actions/applicationActions'
import { messageAction } from 'actions/messageActions'
import ContextMenu from 'ContextMenu'
import showContextMenu from 'helpers/showContextMenu'
import { makeUiPropSelector, makeMapRefSelector } from 'components/MultiImager/selectors'
import { makeDoorEntityPropSelector, makeDoorEntitySelectedSelector, makeDeviceWireSelectedSelector } from 'selectors/components'
import { UNSELECTED_COLORS } from 'helpers/globals'

const makeMapStateToProps = _ => {
  const locationSelector = makeDoorEntityPropSelector('location')
  const markerSelector = makeDoorEntityPropSelector('marker')
  const fillMarkerSelector = makeDoorEntityPropSelector('fillMarker')
  const lockedSelector = makeDoorEntityPropSelector('locked')
  const nameSelector = makeDoorEntityPropSelector('name')
  const removeSelector = makeDoorEntityPropSelector('remove')
  const colorSelector = makeDoorEntityPropSelector('color')
  const mapRefSelector = makeMapRefSelector()
  const doorEntitySelectedSelector = makeDoorEntitySelectedSelector()
  const drawingWallSelector = makeUiPropSelector('drawingWall')
  const drawingWireSelector = makeUiPropSelector('drawingWire')
  const wireSelectedSelector = makeDeviceWireSelectedSelector()

  const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    location: locationSelector(state, ownProps),
    marker: markerSelector(state, ownProps),
    fillMarker: fillMarkerSelector(state, ownProps),
    locked: lockedSelector(state, ownProps),
    name: nameSelector(state, ownProps),
    remove: removeSelector(state, ownProps),
    color: colorSelector(state, ownProps),
    map: mapRefSelector(state),
    activeInUI: doorEntitySelectedSelector(state, ownProps),
    drawing: drawingWallSelector(state) || drawingWireSelector(state),
    type: ownProps.isController ? 'Door Controller' : 'Door',
    wireSelected: wireSelectedSelector(state, { id: ownProps.id, objType: ownProps.isController ? 'doorController' : 'door' })
  })
  return mapStateToProps
}

class DoorEntity extends React.Component {
  componentDidMount() {
    const { remove, props: { id, map, isController, updateEntityAction, classes } } = this

    this.contextMenu = new ContextMenu(map, this.contextMenuOptions(classes))

    this.fillMarker.addListener('contextmenu', showContextMenu(this.contextMenu))
    google.maps.event.addListener(this.contextMenu, 'menu_item_selected', this.eventHandler)

    this.fillMarker.addListener('mousedown', this.setCurrentIfApplicable)
    updateEntityAction(isController ? 'doorControllers' : 'doors', id, { marker: this.marker, fillMarker: this.fillMarker, remove })
  }

  componentWillUnmount = _ => this.remove()

  setCurrentIfApplicable = _ => {
    const { drawing, activeInUI, updateCurrentEntityAction, id, isController } = this.props
    if (drawing) return
    if (!activeInUI) updateCurrentEntityAction({ id, type: isController ? 'doorController' : 'door' })
  }

  contextMenuOptions(classes) {
    const menuItemBuilder = function() {
      const { locked, type } = this.props
      const items = [
        {
          className: classes.contextMenuItem,
          eventName: 'lockDoorEntity',
          id: 'menu_item_lock_door_entity',
          label: `${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={locked ? 'unlock' : 'lock'} />)} ${(locked ? 'Unlock' : 'Lock')} ${type}`
        },
        {
          className: classes.contextMenuItem,
          eventName: 'deleteDoorEntity',
          id: 'menu_item_delete_door_entity',
          label: `${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={['far', 'trash-alt']} />)} Delete ${type}`
        }
      ]

      return items
    }
    return {
      classNames: {
        menu: classes.contextMenu,
        menuSeparator: classes.contextMenuSeparator
      },
      menuItems: menuItemBuilder.bind(this)
    }
  }

  eventHandler = (_, eventName) => {
    const { id, locked, name, type, isController, updateEntityAction, messageAction, destroyDoorControllerAction,
      deleteDoorAction } = this.props

    switch (eventName) {
      case 'lockDoorEntity':
        updateEntityAction(isController ? 'doorControllers' : 'doors', id, { locked: !locked })
        break
      case 'deleteDoorEntity':
        if (locked) {
          messageAction('generalError', `Cannot delete locked ${type}. Right click to unlock.`)
        } else if (window.confirm(`Are you sure you want to delete ${name}?`)) {
          if (isController) {
            destroyDoorControllerAction(id)
          } else {
            deleteDoorAction(id)
          }
        }
        break
    }
    return this.contextMenu.hide()
  }

  remove = _ => {
    this.marker.setMap(null)
    this.fillMarker.setMap(null)
  }

  setMarker = marker => this.marker = marker
  setFillMarker = marker => this.fillMarker = marker

  render() {
    const { setMarker, setFillMarker, props: { location, map, color, locked, id, activeInUI, wireSelected, isController, messageAction, updateEntityAction } } = this
    const displayColor = (activeInUI || wireSelected) ? color : UNSELECTED_COLORS[color]

    return (
      <div>
        <Marker { ...{ setMarker, setFillMarker, position: new google.maps.LatLng(location), map, color: displayColor, locked, id, messageAction, updateEntityAction, isController } } />
      </div>
    )
  }
}

export default connect(makeMapStateToProps, { updateEntityAction, destroyDoorControllerAction, deleteDoorAction, messageAction,
  updateCurrentEntityAction })(injectSheet(style)(DoorEntity))



// WEBPACK FOOTER //
// ./src/components/DoorEntity/index.js